import { useLocation } from 'react-router-dom';
import { faClose } from '@fortawesome/pro-regular-svg-icons';
import * as CampaignPinAction from 'components/sidebar/CampaignPinAction';
import * as SidebarLink from 'components/sidebar/SidebarLink';
import { TruncatedText } from 'components/truncated-text';
import { IntercomProductTourTargets } from 'constants/intercom';
import { useCurrentAccount } from 'customHooks/useCurrentAccount';
import { uniqBy } from 'lodash';
import { twMerge } from 'tailwind-merge';

const RecentAndPinned = () => {
    const location = useLocation();
    const { access, accountId, recentCampaigns, pinnedCampaigns } = useCurrentAccount();
    const allCampaigns = uniqBy([...pinnedCampaigns, ...recentCampaigns], 'id');

    if (!access.pages.includes('campaigns') || allCampaigns.length === 0) return null;

    return (
        <div data-intercom-target={IntercomProductTourTargets.SidebarPinnedContainer}>
            <div
                className="px-3 py-1 text-xs"
                data-intercom-target={IntercomProductTourTargets.SidebarPinnedTitle}
            >
                <div className="font-medium text-gray-600">Recent & Pinned</div>
            </div>
            <ul>
                {allCampaigns
                    .filter(campaign => campaign.type !== 'external')
                    .slice(0, 5)
                    .map(campaign => (
                        <li key={campaign.id} className="group/list-item">
                            <SidebarLink.Link
                                to={`/accounts/${accountId}/campaigns/${campaign.id}/${
                                    campaign.type === 'general' ? 'sharing' : 'details'
                                }`}
                            >
                                <SidebarLink.LevelOne
                                    isActive={
                                        location.pathname ===
                                        `/accounts/${accountId}/campaigns/${campaign.id}`
                                    }
                                    icon={campaign.is_pinned ? 'pinTack' : 'circleHalfDottedClock'}
                                    iconProps={{ className: 'text-gray-400' }}
                                    rightAdornment={
                                        <CampaignPinAction.Root>
                                            <CampaignPinAction.Trigger
                                                campaign={campaign}
                                                icon={campaign.is_pinned ? faClose : undefined}
                                                className={twMerge(
                                                    'hidden rounded-full hover:bg-gray-200 group-hover/menu:flex',
                                                )}
                                            >
                                                {campaign.is_pinned ? 'Unpin' : 'Pin'}
                                            </CampaignPinAction.Trigger>
                                            <CampaignPinAction.TooltipContent>
                                                <p>{campaign.is_pinned ? 'Unpin' : 'Pin '}</p>
                                            </CampaignPinAction.TooltipContent>
                                        </CampaignPinAction.Root>
                                    }
                                >
                                    <span className="flex max-w-32 font-normal 2xl:max-w-44">
                                        <TruncatedText delayDuration={1200}>
                                            {campaign.title}
                                        </TruncatedText>
                                    </span>
                                </SidebarLink.LevelOne>
                            </SidebarLink.Link>
                        </li>
                    ))}
            </ul>
        </div>
    );
};

export { RecentAndPinned };
